import { createFileRoute, Navigate } from '@tanstack/react-router'
import { RoleRestrictedContent } from '@/components/molecules/RoleRestrictedContent/RoleRestrictedContent'
import { UserType } from '@/hooks'
import { InvoiceData } from '@/features/DataManagement/components/InvoiceData/InvoiceData'
import { useFeatureFlag } from '@/components/providers/FeatureFlagsProvider/useFeatureFlag'

export const Route = createFileRoute('/_layout/data-management/invoice-data')({
    component: RouteComponent,
})

function RouteComponent() {
    const isDataManagementEnabled = useFeatureFlag('dataManagement')

    if (!isDataManagementEnabled) {
        return <Navigate to="/dashboard" />
    }

    return (
        <>
            <RoleRestrictedContent
                allowedRoles={[UserType.AGENT, UserType.BROKER]}
            >
                <Navigate to={'/dashboard'} />
            </RoleRestrictedContent>

            <RoleRestrictedContent
                allowedRoles={[UserType.CUSTOMER]}
                strict={false}
            >
                <InvoiceData />
            </RoleRestrictedContent>
        </>
    )
}
